import * as React from 'react';

import styles from './styles.css';

export const loadingIcon = (color: 'black' | 'white'): React.ReactElement => (
    <svg
        className={styles.spinAnimation}
        width="20"
        height="20"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill={color}>
            <path
                opacity={0.2}
                d="M20 11C20 16.5228 15.5228 21 10 21C4.47715 21 0 16.5228 0 11C0 5.47715 4.47715 1 10 1C15.5228 1 20 5.47715 20 11ZM2 11C2 15.4183 5.58172 19 10 19C14.4183 19 18 15.4183 18 11C18 6.58172 14.4183 3 10 3C5.58172 3 2 6.58172 2 11Z"
            />
            <path d="M5.41644 4.4472C6.73338 3.52183 8.34131 2.98388 10.0735 2.99748C11.7377 3.01055 13.2793 3.53087 14.5526 4.41058L16.0144 2.99924C14.3631 1.75759 12.3138 1.01502 10.0892 0.997543C7.81123 0.979651 5.70517 1.72487 4.01373 2.99428L5.41644 4.4472Z" />
        </g>
    </svg>
);
